import React from 'react';
import styled from 'styled-components';
import { Fade } from "react-awesome-reveal";
import h2 from '../Images/h2.png'

// --- Styled Components ---

const AboutSection = styled.section`
  padding: 5px 20px; /* reduced top/bottom spacing */
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 25px; /* reduced gap between text and image */

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const TextColumn = styled.div`
  flex: 1.2;
`;

const ImageColumn = styled.div`
  flex: 0.8;
  width: 100%;
  
  img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    display: block;
  }
`;

const MainTitle = styled.h2`
  font-size: 3rem; /* increased font */
  color: #439E6D;
  margin: 0 0 5px 0; /* reduced spacing */
  font-weight: 700;
`;

const SubTitle = styled.p`
  font-size: 1.2rem; /* increased font */
  color: #666;
  margin-bottom: 20px; /* reduced spacing */
`;

const SectionHeader = styled.h3`
  font-size: 2.2rem; /* increased font */
  color: #439E6D;
  margin: 0 0 15px 0; /* reduced spacing */
  font-weight: 600;
`;

const HighlightTitle = styled.h4`
  font-size: 1.9rem; /* increased font */
  color: #439E6D;
  margin: 0 0 10px 0; /* reduced spacing */
  font-weight: 700;
`;

const Description = styled.p`
  font-size: 1.15rem; /* increased font */
  line-height: 1.6;
  color: #555;
  margin: 0;
`;

// --- Component ---

const About1 = () => {
  return (
    <AboutSection>
      <FlexContainer>
        
        {/* Left Side: Content */}
        <TextColumn>
          <Fade direction="up" triggerOnce cascade damping={0.1}>
            <MainTitle>About Us</MainTitle>
            <SubTitle>
              About our company, our staff, mode of operation and company policy
            </SubTitle>
            
            <SectionHeader>WHO we are</SectionHeader>
            
            <HighlightTitle>Innovation that excites</HighlightTitle>

            <Description>
              PGSL is a Civil Engineering Designs and Construction, Steel Fabrication and 
              piping, Project Management, Engineering Technical Services, Maintenance, 
              Procurement, Environmental services, Geographical information 
              management, Onshore and Offshore surveying and positioning Services 
              (including offshore sub-surface positioning, geophysical and geotechnical 
              surveys), as well as Logistics Services.
            </Description>
          </Fade>
        </TextColumn>

        {/* Right Side: Image */}
        <ImageColumn>
          <Fade direction="right" triggerOnce delay={200}>
            <img 
              src={h2} 
              alt="PGSL Team or Project Site" 
            />
          </Fade>
        </ImageColumn>

      </FlexContainer>
    </AboutSection>
  );
};

export default About1;